import React from "react";

/**
 * Small "Crafted by 7thEdge Solutions" attribution. Rendered in the footer of
 * every layout (AppShell, HR / Management / Accounting shells, Login, Kiosk, POS).
 */
export default function CraftedBy({ tone = "muted", className = "" }) {
  const color = tone === "onDark" ? "rgba(231,208,173,0.55)" : "#A58F7C";
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] ${className}`}
      style={{ color }}
      data-testid="crafted-by"
    >
      Crafted by
      <a
        href="https://7thedge.ng"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold underline-offset-2 hover:underline"
        style={{ color: tone === "onDark" ? "#C49A4A" : "#8B1E1E" }}
      >
        7thEdge Solutions
      </a>
    </span>
  );
}
